import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { TogglePublished } from '@/api/types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useTogglePublishedThread = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const toggleThreadPublished = async (threadId: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
    });

    const response = await fetch(
      `${APIBaseChronos}/api/case/${caseId}/thread/${threadId}/toggle-published`,
      fetchConfig,
    );
    if (!response.ok) {
      throw new Error('Toggling thread published status failed');
    }
    return await response.json();
  };

  return useMutation<TogglePublished, Error, string>({
    mutationFn: (threadId) => toggleThreadPublished(threadId),
    onSuccess: (_data, threadId) => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.ThreadStatus, threadId] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Threads, caseId] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.PublishedThreads, caseId] });
    },
  });
};

export default useTogglePublishedThread;
